module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-5-desktop.jpg?v=d73ee03e";